import { formatShortDate } from '../../utils/formatDate';

export default function ACBreakdownTable({ data }) {
  if (!data || data.length === 0) return null;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5">
      <h3 className="font-semibold text-gray-800 mb-4">Assembly Constituency Breakdown</h3>
      <div className="overflow-x-auto">
        <table className="min-w-[600px] w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-2 px-3 text-gray-500 font-medium">AC Name</th>
              <th className="text-right py-2 px-3 text-gray-500 font-medium">Total</th>
              <th className="text-right py-2 px-3 text-gray-500 font-medium">Submitted</th>
              <th className="text-right py-2 px-3 text-gray-500 font-medium">Approved</th>
              <th className="text-right py-2 px-3 text-gray-500 font-medium">Rejected</th>
              <th className="text-right py-2 px-3 text-gray-500 font-medium">Last Import</th>
            </tr>
          </thead>
          <tbody>
            {data.map(row => (
              <tr key={row.id} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="py-2 px-3 font-medium">{row.name} ({row.code})</td>
                <td className="text-right py-2 px-3">{row.total}</td>
                <td className="text-right py-2 px-3 text-blue-600">{row.submitted}</td>
                <td className="text-right py-2 px-3 text-green-600">{row.approved}</td>
                <td className="text-right py-2 px-3 text-red-600">{row.rejected}</td>
                <td className="text-right py-2 px-3 text-gray-500">{formatShortDate(row.last_import)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
